// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Defines label color variables on a class for each label color name.
 * Consumers of labels outside of their components can import this LESS file,
 * which will load up CSS variables on any element with the corresponding class
 * name (e.g. \`.green\`).
 */
.phHOwzb38SgqE0 {
  --label-background-color: var(--ds-background-accent-green-subtler, #baf3db);
  --label-background-color-hovered: var(--ds-background-accent-green-subtler-hovered, #7ee2b8);
  --label-text-color: var(--ds-text-accent-green-bolder, #164b35);
}
.j9JIodrhFTlsIh {
  --label-background-color: var(--ds-background-accent-green-subtle, #4bce97);
  --label-background-color-hovered: var(--ds-background-accent-green-subtle-hovered, #7ee2b8);
  --label-text-color: var(--ds-text-accent-green-bolder, #164b35);
}
.wXv70GehF02n7H {
  --label-background-color: var(--ds-background-accent-green-bolder, #1f845a);
  --label-background-color-hovered: var(--ds-background-accent-green-bolder-hovered, #216e4e);
  --label-text-color: var(--ds-text-inverse, #ffffff);
}
.rX4KXPBRPuaib6 {
  --label-background-color: var(--ds-background-accent-yellow-subtler, #f8e6a0);
  --label-background-color-hovered: var(--ds-background-accent-yellow-subtler-hovered, #f5cd47);
  --label-text-color: var(--ds-text-accent-yellow-bolder, #533f04);
}
.hu6gtEc5qSemk7 {
  --label-background-color: var(--ds-background-accent-yellow-subtle, #e2b203);
  --label-background-color-hovered: var(--ds-background-accent-yellow-subtle-hovered, #f5cd47);
  --label-text-color: var(--ds-text-accent-yellow-bolder, #533f04);
}
.RaUkVxYN9Iqh0H {
  --label-background-color: var(--ds-background-accent-yellow-bolder, #946f00);
  --label-background-color-hovered: var(--ds-background-accent-yellow-bolder-hovered, #7f5f01);
  --label-text-color: var(--ds-text-inverse, #ffffff);
}
.oJ3H5HIWGEee3w {
  --label-background-color: var(--ds-background-accent-orange-subtler, #ffe2bd);
  --label-background-color-hovered: var(--ds-background-accent-orange-subtler-hovered, #fec57b);
  --label-text-color: var(--ds-text-accent-orange-bolder, #5f3811);
}
.iQMt8rPYa7muhd {
  --label-background-color: var(--ds-background-accent-orange-subtle, #faa53d);
  --label-background-color-hovered: var(--ds-background-accent-orange-subtle-hovered, #fec57b);
  --label-text-color: var(--ds-text-accent-orange-bolder, #5f3811);
}
.wRolJQK84JDukW {
  --label-background-color: var(--ds-background-accent-orange-bolder, #b65c02);
  --label-background-color-hovered: var(--ds-background-accent-orange-bolder-hovered, #974f0c);
  --label-text-color: var(--ds-text-inverse, #ffffff);
}
.hdvbSvHCNTUHsx {
  --label-background-color: var(--ds-background-accent-red-subtler, #ffd2cc);
  --label-background-color-hovered: var(--ds-background-accent-red-subtler-hovered, #ff9c8f);
  --label-text-color: var(--ds-text-accent-red-bolder, #601e16);
}
.yFXbFbenqWqXj7 {
  --label-background-color: var(--ds-background-accent-red-subtle, #f87462);
  --label-background-color-hovered: var(--ds-background-accent-red-subtle-hovered, #ff9c8f);
  --label-text-color: var(--ds-text-accent-red-bolder, #601e16);
}
.B43HlqGqKxtpCC {
  --label-background-color: var(--ds-background-accent-red-bolder, #ca3521);
  --label-background-color-hovered: var(--ds-background-accent-red-bolder-hovered, #ae2a19);
  --label-text-color: var(--ds-text-inverse, #ffffff);
}
.ePkbtn5R2hDYa5 {
  --label-background-color: var(--ds-background-accent-purple-subtler, #dfd8fd);
  --label-background-color-hovered: var(--ds-background-accent-purple-subtler-hovered, #b8acf6);
  --label-text-color: var(--ds-text-accent-purple-bolder, #352c63);
}
.ANCPgNg0LjnzHi {
  --label-background-color: var(--ds-background-accent-purple-subtle, #9f8fef);
  --label-background-color-hovered: var(--ds-background-accent-purple-subtle-hovered, #b8acf6);
  --label-text-color: var(--ds-text-accent-purple-bolder, #352c63);
}
.sTVm2_HvL1NkEh {
  --label-background-color: var(--ds-background-accent-purple-bolder, #6e5dc6);
  --label-background-color-hovered: var(--ds-background-accent-purple-bolder-hovered, #5e4db2);
  --label-text-color: var(--ds-text-inverse, #ffffff);
}
.RFhaUWoySJjtKm {
  --label-background-color: var(--ds-background-accent-blue-subtler, #cce0ff);
  --label-background-color-hovered: var(--ds-background-accent-blue-subtler-hovered, #85b8ff);
  --label-text-color: var(--ds-text-accent-blue-bolder, #09326c);
}
.Ou3mC2KxHJuIBF {
  --label-background-color: var(--ds-background-accent-blue-subtle, #579dff);
  --label-background-color-hovered: var(--ds-background-accent-blue-subtle-hovered, #85b8ff);
  --label-text-color: var(--ds-text-accent-blue-bolder, #09326c);
}
.Q9ZePDLhDjUg5Q {
  --label-background-color: var(--ds-background-accent-blue-bolder, #0c66e4);
  --label-background-color-hovered: var(--ds-background-accent-blue-bolder-hovered, #0055cc);
  --label-text-color: var(--ds-text-inverse, #ffffff);
}
.p4lfS7rZTGgeqJ {
  --label-background-color: var(--ds-background-accent-teal-subtler, #c1f0f5);
  --label-background-color-hovered: var(--ds-background-accent-teal-subtler-hovered, #8bdbe5);
  --label-text-color: var(--ds-text-accent-teal-bolder, #1d474c);
}
.nakRHkzGmtthvE {
  --label-background-color: var(--ds-background-accent-teal-subtle, #60c6d2);
  --label-background-color-hovered: var(--ds-background-accent-teal-subtle-hovered, #8bdbe5);
  --label-text-color: var(--ds-text-accent-teal-bolder, #1d474c);
}
.hdfsmuVVjnJdoS {
  --label-background-color: var(--ds-background-accent-teal-bolder, #1d7f8c);
  --label-background-color-hovered: var(--ds-background-accent-teal-bolder-hovered, #206b74);
  --label-text-color: var(--ds-text-inverse, #ffffff);
}
.EWTC4LlnV1Md9d {
  --label-background-color: var(--ds-background-accent-lime-subtler, #D3F1A7);
  --label-background-color-hovered: var(--ds-background-accent-lime-subtler-hovered, #b3df72);
  --label-text-color: var(--ds-text-accent-lime-bolder, #37471f);
}
.BJgV1dTvMCTXG9 {
  --label-background-color: var(--ds-background-accent-lime-subtle, #94c748);
  --label-background-color-hovered: var(--ds-background-accent-lime-subtle-hovered, #b3df72);
  --label-text-color: var(--ds-text-accent-lime-bolder, #37471f);
}
.fDt3jnrY2Wvar9 {
  --label-background-color: var(--ds-background-accent-lime-bolder, #5b7f24);
  --label-background-color-hovered: var(--ds-background-accent-lime-bolder-hovered, #4c6b1f);
  --label-text-color: var(--ds-text-inverse, #ffffff);
}
.kyehoWpV6zF3Kj {
  --label-background-color: var(--ds-background-accent-magenta-subtler, #fdd0ec);
  --label-background-color-hovered: var(--ds-background-accent-magenta-subtler-hovered, #f797d2);
  --label-text-color: var(--ds-text-accent-magenta-bolder, #50253f);
}
.dk_Hldxx_zbSWO {
  --label-background-color: var(--ds-background-accent-magenta-subtle, #e774bb);
  --label-background-color-hovered: var(--ds-background-accent-magenta-subtle-hovered, #f797d2);
  --label-text-color: var(--ds-text-accent-magenta-bolder, #50253f);
}
.lZgYFrgpAHLTu2 {
  --label-background-color: var(--ds-background-accent-magenta-bolder, #ae4787);
  --label-background-color-hovered: var(--ds-background-accent-magenta-bolder-hovered, #943d73);
  --label-text-color: var(--ds-text-inverse, #ffffff);
}
.U6gER8h8nIzGMA {
  --label-background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
  --label-background-color-hovered: var(--ds-background-accent-gray-subtler-hovered, #b3b9c4);
  --label-text-color: var(--ds-text-accent-gray-bolder, #091e42);
}
.eeLISBfHTfYh8L {
  --label-background-color: var(--ds-background-accent-gray-subtle, #8590a2);
  --label-background-color-hovered: var(--ds-background-accent-gray-subtle-hovered, #b3b9c4);
  --label-text-color: var(--ds-text-accent-gray-bolder, #091e42);
}
.sU9abKmpWu06tm {
  --label-background-color: var(--ds-background-accent-gray-bolder, #626f86);
  --label-background-color-hovered: var(--ds-background-accent-gray-bolder-hovered, #44546f);
  --label-text-color: var(--ds-text-inverse, #ffffff);
}
.kncNzJ_M0ejtxQ {
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  min-width: 56px;
  max-width: 100%;
  height: 16px;
  margin-bottom: var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0) 8px;
  overflow: hidden;
  border-radius: var(--ds-border-radius-100, 4px);
  background-color: var(--label-background-color);
  color: var(--label-text-color);
  font-size: 12px;
  font-weight: var(--ds-font-weight-medium, 500);
  line-height: 16px;
  text-align: left;
  text-overflow: ellipsis;
  vertical-align: middle;
  white-space: nowrap;
}
.body-color-blind-mode-enabled .kncNzJ_M0ejtxQ:not(.CnKieIJuB63L2q),
.body-color-blind-mode-enabled ~ div .kncNzJ_M0ejtxQ:not(.CnKieIJuB63L2q) {
  --adjusted-padding-left: calc((8px / 2) + 16px);
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  padding-left: var(--adjusted-padding-left);
}
.body-color-blind-mode-enabled .kncNzJ_M0ejtxQ:not(.CnKieIJuB63L2q)::before,
.body-color-blind-mode-enabled ~ div .kncNzJ_M0ejtxQ:not(.CnKieIJuB63L2q)::before {
  content: '';
  position: absolute;
  top: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 16px;
  height: 16px;
  border-radius: var(--ds-border-radius-100, 4px);
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  background-color: var(--label-text-color);
  mask-repeat: repeat-y;
}
.kcP1FJQC508ukM {
  min-width: 40px;
  max-width: 40px;
  height: 8px;
  margin-top: var(--ds-space-0, 0);
  margin-bottom: var(--ds-space-0, 0);
  padding-right: 0;
  padding-left: 0;
  color: transparent;
}
.body-color-blind-mode-enabled .kcP1FJQC508ukM:not(.CnKieIJuB63L2q)::before,
.body-color-blind-mode-enabled ~ div .kcP1FJQC508ukM:not(.CnKieIJuB63L2q)::before {
  right: var(--ds-space-0, 0);
  width: 100%;
  height: 100%;
  border-radius: 0;
  mask-repeat: repeat;
}
.Nr5LU1uZcGfjEe:hover {
  background-color: var(--label-background-color-hovered);
  cursor: pointer;
}
@keyframes Qc9VHcX6y6E1GL {
  0% {
    padding-right: 0;
    padding-left: 0;
    transform: scaleY(0.5);
    color: transparent;
  }
  66% {
    padding-right: 8px;
    padding-left: 8px;
    transform: scaleY(1);
  }
  100% {
    padding-right: 8px;
    /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
    padding-left: calc(var(--adjusted-padding-left, 8px));
    transform: scaleY(1);
    color: transparent;
  }
}
@keyframes SYecr_d607pbN0 {
  0% {
    max-width: var(--expanded-max-width, 100%);
    transform: scaleY(1.5);
    color: transparent;
  }
  66% {
    transform: scaleY(1.5);
  }
  100% {
    max-width: 40px;
    transform: scaleY(1);
    color: transparent;
  }
}
@keyframes ZIUjwxlmndzCuq {
  0%,
  99% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.body-card-label-text-on .kncNzJ_M0ejtxQ {
  animation-name: Qc9VHcX6y6E1GL;
  animation-duration: 450ms;
  animation-timing-function: ease-out;
}
.body-card-label-text-on.body-color-blind-mode-enabled .kncNzJ_M0ejtxQ:not(.CnKieIJuB63L2q)::before,
.body-card-label-text-on.body-color-blind-mode-enabled ~ div .kncNzJ_M0ejtxQ:not(.CnKieIJuB63L2q)::before {
  animation-name: ZIUjwxlmndzCuq;
  animation-duration: 450ms;
  animation-timing-function: ease-out;
}
.body-card-label-text-off .kncNzJ_M0ejtxQ {
  animation-name: SYecr_d607pbN0;
  animation-duration: 450ms;
  animation-timing-function: ease-in;
  animation-fill-mode: forwards;
}
.body-card-label-text-off.body-color-blind-mode-enabled .kncNzJ_M0ejtxQ:not(.CnKieIJuB63L2q)::before,
.body-card-label-text-off.body-color-blind-mode-enabled ~ div .kncNzJ_M0ejtxQ:not(.CnKieIJuB63L2q)::before {
  animation-name: ZIUjwxlmndzCuq;
  animation-duration: 450ms;
  animation-timing-function: ease-in;
  animation-fill-mode: forwards;
}
`, ""]);
// Exports
export var green_light = `phHOwzb38SgqE0`;
export var green = `j9JIodrhFTlsIh`;
export var green_dark = `wXv70GehF02n7H`;
export var yellow_light = `rX4KXPBRPuaib6`;
export var yellow = `hu6gtEc5qSemk7`;
export var yellow_dark = `RaUkVxYN9Iqh0H`;
export var orange_light = `oJ3H5HIWGEee3w`;
export var orange = `iQMt8rPYa7muhd`;
export var orange_dark = `wRolJQK84JDukW`;
export var red_light = `hdvbSvHCNTUHsx`;
export var red = `yFXbFbenqWqXj7`;
export var red_dark = `B43HlqGqKxtpCC`;
export var purple_light = `ePkbtn5R2hDYa5`;
export var purple = `ANCPgNg0LjnzHi`;
export var purple_dark = `sTVm2_HvL1NkEh`;
export var blue_light = `RFhaUWoySJjtKm`;
export var blue = `Ou3mC2KxHJuIBF`;
export var blue_dark = `Q9ZePDLhDjUg5Q`;
export var sky_light = `p4lfS7rZTGgeqJ`;
export var sky = `nakRHkzGmtthvE`;
export var sky_dark = `hdfsmuVVjnJdoS`;
export var lime_light = `EWTC4LlnV1Md9d`;
export var lime = `BJgV1dTvMCTXG9`;
export var lime_dark = `fDt3jnrY2Wvar9`;
export var pink_light = `kyehoWpV6zF3Kj`;
export var pink = `dk_Hldxx_zbSWO`;
export var pink_dark = `lZgYFrgpAHLTu2`;
export var black_light = `U6gER8h8nIzGMA`;
export var black = `eeLISBfHTfYh8L`;
export var black_dark = `sU9abKmpWu06tm`;
export var compactLabel = `kncNzJ_M0ejtxQ`;
export var colorless = `CnKieIJuB63L2q`;
var _1 = `kcP1FJQC508ukM`;
export { _1 as "compactLabel--collapsed" };
var _2 = `Nr5LU1uZcGfjEe`;
export { _2 as "compactLabel--hoverable" };
export var expandLabels = `Qc9VHcX6y6E1GL`;
export var togglePattern = `ZIUjwxlmndzCuq`;
export var collapseLabels = `SYecr_d607pbN0`;
export default ___CSS_LOADER_EXPORT___;
